<app-header></app-header>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
